<template>
    <div class="HomeHeader">
        <div class="header-left" >
            <img src="@/assets/images/mpc/logo.png">
            <!-- <span>{{$t("home.logoText")}}</span> -->
        </div>
        <div class="header-right">
            <div class="walletShow" v-if="walletAddress">{{showAddress(walletAddress)}}</div>
            <div class="language">
                <el-dropdown @command="selectLang" trigger="click"  slot="dropdown">
                    <div class="dropdown-btn">
                        <img src="@/assets/images/mpc/language-cn.png" class="icon" v-if="curLang=='zh_cn'"/>
                        <img src="@/assets/images/mpc/language-en.png" class="icon" v-if="curLang=='en_us'"/>
                    </div>
                    <el-dropdown-menu class="language-dropdown">
                        <el-dropdown-item command="zh_cn" class="first">
                            <div>
                                <img src="@/assets/images/mpc/language-cn.png" class="icon"/>
                                <span>中文简体</span>
                            </div>
                        </el-dropdown-item>
                        <el-dropdown-item command="en_us" class="last">
                            <div>
                                <img src="@/assets/images/mpc/language-en.png" class="icon"/>
                                <span>English</span>
                            </div>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
    </div>
</template>
<script>
import bus from '@/assets/js/bus';
import {getLanguage,setLanguage} from '@/assets/js/config';
import { getUserName,getUserSign } from '@/assets/js/user';
export default {
    data() {
        return {
            walletAddress:"",
            curLang:"",
        };
    },
    created(){
        this.curLang = getLanguage() || 'zh_cn';
        bus.$on('showWalletAddress',async() =>  {
            this.walletAddress = getUserName();
        });
        bus.$on('clearWalletAddress',async() =>  {
            this.walletAddress = "";
        });
        if(getUserName()){
            this.walletAddress = getUserName();
        }
    },
    // mounted() {
    //     this.showNoticeBox();
    // },
    methods:{
        selectLang(command){
            setLanguage(command);
            this.$i18n.locale = command;
            bus.$emit('changeLang');
        }
    }
}
</script>
<style lang='less'>
.language-dropdown{
    padding:0px;
    border: none;
    .el-dropdown-menu__item{
        font-size: 14px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        height: 40px;
        // width: 80px;
        line-height: 40px;
        text-align: center;
        >div{
            display: flex;
            align-items: center;
            justify-content: flex-start;
            gap:10px;
            img{
                width: 20px;
                height: 20px;
                border-radius: 100%;  
            }
            span{
                font-size: 12px;
                color: #000;
            }
        }
    }
    .el-dropdown-menu__item:hover{
        background-color: #eeeeee;
    }
    .first{
        border-radius: 10px 10px 0px 0px ;
    }
    .last{
        border-bottom: none!important;
        border-radius: 0px 0px 10px 10px;
    }
}
</style>
<style lang='less' scoped>
.HomeHeader{
    display:flex;
    align-items:center;
    justify-content: space-between;
    // background: linear-gradient(90deg, #0089E0, #00429A);
    .header-left{
        display:flex;
        align-items:center;
        margin-left:8px;
        img{
            height: 26px;
            width: auto; 
        }
        span{
            color: #fff;
            font-size: 16px;
            font-weight: bolder;
            margin-left:4px;
        }
    }
    .header-right {
        display:flex;
        justify-content:flex-end;
        align-items:center;
        margin-right: 8px;
        gap:10px;
        .notice{
            font-size: 20px;
            cursor:pointer;
            color: #fff;
        }
        .notice:active,.notice:hover{
            color: #7E9DC9;
        }
        .language{
            display:flex;
            align-items:center;
            .dropdown-btn{
                display: flex;
                img{
                    cursor:pointer;
                    height: 20px;
                    width: 20px;  
                    border-radius: 100%;  
                }
            }
        }
        .walletShow{
            font-size:13px;
            font-weight: 600;
            cursor:pointer;
            color: #fff;
        }
    }
}
</style>